let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ikem6"), load("6wr18"), load("ffEVr"), load("Wowvf"), load("hhss7"), load("hs6o8")]).then(() => parcelRequire('kB13O'));